module.exports = __webpack_public_path__ + "img/tree.dcd7e010.svg";